import { useMutation, useQueryClient } from "@tanstack/react-query";
import client from "api/graphql/getClient";
import { graphql } from "gql/gql";
import { DeleteSlackWorkspaceParams } from "gql/graphql";
import { useActiveAccount } from "utils/useActiveAccount";

const deleteSlackWorkspaceDocument = graphql(/* GraphQL */ `
	mutation deleteSlackWorkspace($params: DeleteSlackWorkspaceParams!) {
		deleteSlackWorkspace(params: $params) {
			error {
				code
				message
			}
			success
		}
	}
`);

interface Args {
	params: DeleteSlackWorkspaceParams;
	userId?: string;
}

const deleteSlackWorkspace = ({ userId, params }: Args) =>
	client(userId)
		.request(deleteSlackWorkspaceDocument, { params })
		.then((res) => res.deleteSlackWorkspace);

const useDeleteSlackWorkspace = () => {
	const { userId, _id } = useActiveAccount();
	const queryClient = useQueryClient();

	return useMutation(
		(params: DeleteSlackWorkspaceParams) =>
			deleteSlackWorkspace({ params, userId }),
		{
			onSettled: () => {
				queryClient.invalidateQueries([
					"user",
					userId,
					"account",
					_id,
					"listSlackWorkspaces",
				]);
			},
		}
	);
};

export default useDeleteSlackWorkspace;
